export const promoCodePlansMapping: Record<string, string> = {
  ["discount:10_percent"]: "10% discount on total project cost",
}
